const articleOverview = document.querySelectorAll('.blog_article_overview');

if (articleOverview) {
  articleOverview.forEach(overview => {
    const postList = overview.querySelector('.postlist');
    const postsPerPage = Number(postList.dataset.blogItems) || 9;
    const posts = postList?.querySelectorAll('.blog_article_col') || [];
    const paginationContainer = overview.querySelector('.blog_article_pagination');
    const paginationButton = paginationContainer?.querySelector('button');
    const sortSelect = overview.querySelector('.blog_article_select');

    if (!postList) {
      console.error('Post list not found!');
      return;
    }

    checkPaginationVisibility(overview, postsPerPage);

    if (paginationButton) {
      paginationButton.addEventListener('click', function (e) {
        e.preventDefault();
        const restPosts = postList.querySelectorAll('.blog_article_col.hidden');

        if (restPosts.length > 0) {
          restPosts.forEach((post, index) => {
            if (index < postsPerPage) {
              post.classList.remove('hidden');
            }
          });
        }

        checkPaginationVisibility(overview, postsPerPage, true);
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function (e) {
        const postListGrid = postList.querySelector('.grid');
        const sortValue = e.target.value;
        const sortedPosts = [...posts].sort((a, b) => {
          const aBlogArticle = a.querySelector('.blog_article');
          const bBlogArticle = b.querySelector('.blog_article');
          const aDate = aBlogArticle.dataset.blogDate;
          const bDate = bBlogArticle.dataset.blogDate;
          const aTop = aBlogArticle.dataset.blogTopPost;
          const bTop = bBlogArticle.dataset.blogTopPost;

          if (sortValue === 'top') {
            if (aTop === '1' && bTop === '1') {
              return 0;
            } else if (aTop === '1' && bTop === '0') {
              return -1;
            } else if (aTop === '0' && bTop === '1') {
              return 1;
            } else {
              return 0;
            }
          } else if (sortValue === 'asc') {
            return aDate - bDate;
          } else {
            return bDate - aDate;
          }
        });

        postListGrid.innerHTML = '';

        sortedPosts.forEach((post, index) => {
          if (index >= postsPerPage) {
            post.classList.add('hidden');
          } else {
            post.classList.remove('hidden');
          }
          postListGrid.appendChild(post);
        });
      });
    }
  });

  function checkPaginationVisibility(overview, postsPerPage, hiddenEl = false) {
    const postsClass = hiddenEl ? '.blog_article_col.hidden' : '.blog_article_col';
    const posts = overview.querySelectorAll(postsClass);
    const paginationContainer = overview.querySelector('.blog_article_pagination');

    if (paginationContainer && posts.length < 1) {
      paginationContainer?.remove();
    }
  }
}
